import {CdkTextareaAutosize} from '@angular/cdk/text-field'
import {DecimalPipe} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {MatCheckbox} from '@angular/material/checkbox'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog'
import {MatFormField} from '@angular/material/form-field'
import {MatInput} from '@angular/material/input'
import {
  blancoHighestThreshold,
  IApplicationLog,
  TApplicationLogType,
  ucLowestThreshold
} from '@sparbanken-syd/loan-backend'
import {WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {LoanService} from '../../../services/loan.service'
import {KalpTypeIndicatorComponent} from '../kalp-logs/kalp-type-indicator/kalp-type-indicator.component'

export interface AddNotesDialogData {
  applicationId: string
  logType: TApplicationLogType
  previousNotes: string[],
  resolved: boolean
}

const nonResolvableLogs = new Set<TApplicationLogType>(['note', 'issue', 'change'])

@Component({
  selector: 'spb-kalp-add-notes',
  templateUrl: './kalp-add-notes.component.html',
  styleUrl: './kalp-add-notes.component.scss',
  imports: [MatDialogTitle, KalpTypeIndicatorComponent, MatCheckbox, ReactiveFormsModule, MatFormField, MatInput, CdkTextareaAutosize, MatDialogActions, MatButton, MatDialogClose, DecimalPipe]
})
export class KalpAddNotesComponent implements OnInit {
  public data = inject<AddNotesDialogData>(MAT_DIALOG_DATA)

  public notes = new FormControl<string | null>(null,
    {nonNullable: true, validators: [Validators.required]})

  public resolved = new FormControl<boolean>(false, {nonNullable: true})

  public resolvable = false

  protected readonly ucLowestThreshold = ucLowestThreshold
  protected readonly blancoHighestThreshold = blancoHighestThreshold

  private readonly loanService = inject(LoanService)
  private readonly dialogRef = inject<MatDialogRef<KalpAddNotesComponent>>(MatDialogRef)
  private readonly dialog = inject(MatDialog)

  ngOnInit() {
    // If previously resolved keep that
    this.resolvable = !nonResolvableLogs.has(this.data.logType)
    this.resolved.setValue(this.data.resolved)
  }

  public save() {
    const waitRef = this.dialog.open(WaitComponent, {
      data: {title: 'Sparar', progress: true}
    })

    const applicationLog: IApplicationLog = {
      date: Date.now(),
      type: this.data.logType,
      notes: this.notes.value as string,
      changes: [],
      user: '',
      override: this.resolved.value
    }

    // Add notes
    this.loanService.addNotes(this.data.applicationId, applicationLog)
      .subscribe(
        () => {
          waitRef.close()
          this.dialogRef.close()
        }
      )
  }
}
